import i18n from 'i18next';
import dadkMpvId from './da-dk.json';
import dedeMpvId from './de-de.json';
import enauMpvId from './en-au.json';
import encaMpvId from './en-ca.json';
import engbMpvId from './en-gb.json';
import enieMpvId from './en-ie.json';
import eninMpvId from './en-in.json';
import ennzMpvId from './en-nz.json';
import enusMpvId from './en-us.json';
import esesMpvId from './es-es.json';
import esusMpvId from './es-us.json';
import fifiMpvId from './fi-fi.json';
import frcaMpvId from './fr-ca.json';
import frfrMpvId from './fr-fr.json';
import ititMpvId from './it-it.json';
import nbnoMpvId from './nb-no.json';
import nlnlMpvId from './nl-nl.json';
import ptptMpvId from './pt-pt.json';
import svseMpvId from './sv-se.json';

type TranslationKeys = keyof typeof enusMpvId;

export function __product(translationKey: TranslationKeys): string {
    return i18n.t(translationKey);
}

export const mpvIdTranslations = {
    dadkMpvId,
    dedeMpvId,
    enauMpvId,
    encaMpvId,
    engbMpvId,
    enieMpvId,
    eninMpvId,
    ennzMpvId,
    enusMpvId,
    esesMpvId,
    esusMpvId,
    fifiMpvId,
    frcaMpvId,
    frfrMpvId,
    ititMpvId,
    nbnoMpvId,
    nlnlMpvId,
    ptptMpvId,
    svseMpvId,
};
